module.exports = {
	"name": "biscotte",
	"version": "0.10.5",
	"description": "A minimalistic framework for server-rendered Vue.js applications (inspired by Next.js)",
	"contributors": [
		{
			"name": "Sebastien Chopin"
		},
		{
			"name": "Alexandre Chopin"
		}
	],
	"main": "./index.js",
	"license": "MIT",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/nuxt/nuxt.js"
	},
	"files": [
		"bin",
		"dist",
		"index.js"
	],
	"keywords": [
		"nuxt",
		"nuxt.js",
		"nuxtjs",
		"vue",
		"vue.js",
		"vuejs",
		"vue universal",
		"vue ssr",
		"vue isomorphic",
		"vue versatile"
	],
	"homepage": "https://github.com/nuxt/nuxt.js#readme",
	"bin": {
		"nuxt": "./bin/nuxt"
	},
	"scripts": {
		"test": "nyc ava --serial test/",
		"coverage": "nyc report --reporter=text-lcov > coverage.lcov && codecov",
		"lint": "eslint --ext .js,.vue bin lib pages test/*.js --ignore-pattern lib/app",
		"build": "webpack",
		"watch": "webpack --watch",
		"precommit": "npm run lint",
		"prepublish": "npm run build"
	},
	"engines": {
		"node": ">=4.3.0 <5.0.0 || >=5.10",
		"npm": ">=3.0.0"
	},
	"dependencies": {
		"ansi-html": "^0.0.7",
		"autoprefixer": "^6.7.7",
		"babel-core": "^6.24.0",
		"babel-loader": "^6.4.1",
		"babel-preset-vue-app": "^0.5.1",
		"chokidar": "^1.6.1",
		"co": "^4.6.0",
		"compression": "^1.6.2",
		"css-loader": "^0.27.3",
		"debug": "^2.6.3",
		"file-loader": "^0.10.1",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"fs-extra": "^2.1.2",
		"glob": "^7.1.1",
		"hash-sum": "^1.0.2",
		"html-minifier": "^3.4.2",
		"html-webpack-plugin": "^2.28.0",
		"lodash": "^4.17.4",
		"lru-cache": "^4.0.2",
		"memory-fs": "^0.4.1",
		"pify": "^2.3.0",
		"post-compile-webpack-plugin": "^0.1.1",
		"preload-webpack-plugin": "^1.2.1",
		"progress-bar-webpack-plugin": "^1.9.3",
		"script-ext-html-webpack-plugin": "^1.7.1",
		"serialize-javascript": "^1.3.0",
		"serve-static": "^1.12.1",
		"url-loader": "^0.5.8",
		"vue": "^2.2.5",
		"vue-loader": "^11.3.3",
		"vue-meta": "^0.5.5",
		"vue-router": "^2.3.0",
		"vue-server-renderer": "^2.2.5",
		"vue-ssr-html-stream": "^2.2.0",
		"vue-ssr-webpack-plugin": "^1.0.2",
		"vue-template-compiler": "^2.2.5",
		"vuex": "^2.2.1",
		"webpack": "^2.3.2",
		"webpack-bundle-analyzer": "^2.3.1",
		"webpack-dev-middleware": "^1.10.1",
		"webpack-hot-middleware": "^2.17.1"
	},
	"devDependencies": {
		"ava": "^0.18.2",
		"babel-eslint": "^7.2.1",
		"babel-plugin-array-includes": "^2.0.3",
		"babel-plugin-transform-async-to-generator": "^6.22.0",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-es2015": "^6.24.0",
		"babel-preset-stage-2": "^6.22.0",
		"codecov": "^2.1.0",
		"copy-webpack-plugin": "^4.0.1",
		"eslint": "^3.18.0",
		"eslint-config-standard": "^8.0.0-beta.2",
		"eslint-plugin-html": "^2.0.1",
		"eslint-plugin-import": "^2.2.0",
		"eslint-plugin-node": "^4.2.1",
		"eslint-plugin-promise": "^3.5.0",
		"eslint-plugin-standard": "^2.1.1",
		"finalhandler": "^1.0.1",
		"jsdom": "^9.12.0",
		"json-loader": "^0.5.4",
		"nyc": "^10.2.0-candidate.0",
		"request": "^2.81.0",
		"request-promise-native": "^1.0.3",
		"webpack-node-externals": "^1.5.4"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 28
// module chunks = 0